import type * as React from "react";
import { createContext, useContext } from "react";
import type { ProjectTemplateStatusAction } from "./ProjectTemplateStatus/projectTemplateStatusActions";
import type { ProjectTemplateStatusState } from "./ProjectTemplateStatus/projectTemplateStatusReducer";
interface ProjectTemplateStatusContextValue {
    state: ProjectTemplateStatusState;
    dispatch: React.Dispatch<ProjectTemplateStatusAction>;
}
const ProjectTemplateStatusContext = createContext<ProjectTemplateStatusContextValue | undefined>(undefined);
export function useProjectTemplateStatusContext(): ProjectTemplateStatusContextValue | undefined {
    return useContext(ProjectTemplateStatusContext);
}
export const ProjectTemplateStatusContextProvider = ProjectTemplateStatusContext.Provider;
